import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { adminLogin } from "@/lib/api";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_kickoff-central-10/artifacts/72zh29ie_Middel%2020%40300x.png";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await adminLogin(formData);
      localStorage.setItem("adminToken", response.data.token);
      localStorage.setItem("adminUser", response.data.username);
      localStorage.setItem("adminRole", response.data.role);
      localStorage.setItem("adminEmail", response.data.email);
      toast.success("Succesvol ingelogd!");
      navigate("/admin");
    } catch (error) {
      toast.error("Ongeldige inloggegevens");
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(224,71%,4%)] px-4" data-testid="admin-login-page">
      <Card className="w-full max-w-md bg-slate-900/50 border-white/10">
        <CardHeader className="text-center">
          <img src={LOGO_URL} alt="Futsal Gent" className="h-20 w-auto mx-auto mb-4" />
          <CardTitle className="text-white font-['Chivo'] text-2xl">Admin Login</CardTitle>
          <p className="text-slate-400 text-sm mt-2">Log in om de Futsal Gent website te beheren</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-slate-300">Gebruikersnaam</Label>
              <Input
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                required
                className="bg-slate-800 border-white/10 text-white placeholder:text-slate-500"
                placeholder="Voer gebruikersnaam in"
                data-testid="admin-username"
              />
            </div>

            <div className="space-y-2">
              <Label htmlFor="password" className="text-slate-300">Wachtwoord</Label>
              <Input
                id="password"
                name="password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                required
                className="bg-slate-800 border-white/10 text-white placeholder:text-slate-500"
                placeholder="Voer wachtwoord in"
                data-testid="admin-password"
              />
            </div>

            <Button 
              type="submit" 
              disabled={loading}
              className="w-full bg-[hsl(217,91%,60%)] hover:bg-[hsl(217,91%,50%)]"
              data-testid="admin-login-submit"
            >
              {loading ? "Inloggen..." : "Inloggen"}
            </Button>
          </form>

        </CardContent>
      </Card>
    </div>
  );
}
